import { queryClient } from "@/config/react-query";

import { formQueryKeys } from "@/api/forms/form-query";
import { noteQueryKeys } from "@/api/provider/scribe/note-query";
import {
  blastQueryKeys,
  cohortQueryKeys,
} from "@/api/query/provider/comms/blast";
import { outreachSequenceQueryKeys } from "@/api/query/provider/comms/outreach-sequence";

/** Map from agent artifact_type → React Query key roots to invalidate. */
const ARTIFACT_QUERY_KEYS: Record<string, readonly (readonly unknown[])[]> = {
  form: [formQueryKeys.all],
  template: [noteQueryKeys.templates()],
  cohort: [cohortQueryKeys.all],
  blast: [blastQueryKeys.all],
  // Service settings actions seed their cache from apply results instead of invalidating.
  outreach_sequence: [outreachSequenceQueryKeys.all],
};

/**
 * Invalidate React Query caches for a completed agent artifact.
 * Called when an actual tool result completes with an artifact_type.
 */
export function invalidateAgentArtifact(artifactType: string): void {
  const keys = ARTIFACT_QUERY_KEYS[artifactType];
  if (!keys) return;
  for (const key of keys) {
    queryClient.invalidateQueries({ queryKey: key });
  }
}
